export default __webpack_public_path__ + "static/media/devices-2.ff8b642b.jpg";